<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>icons / 24x24 / register</title>
    <g
      id="icons-/-24x24-/-register"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <g
        id="log-out"
        transform="translate(3.000000, 3.000000)"
        stroke="#97ABBE"
        stroke-width="2"
      >
        <path
          d="M6,18 L2,18 C0.8954305,18 0,17.1045695 0,16 L0,2 C0,0.8954305 0.8954305,0 2,0 L6,0"
          id="Path"
        ></path>
        <polyline id="Path" points="13 14 18 9 13 4"></polyline>
        <line x1="18" y1="9" x2="6" y2="9" id="Path"></line>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "icon"
};
</script>